import clsx from 'clsx';
import React from 'react';
import { UiFlex } from '../../flex/UiFlex';
import { UiPadding } from '../../padding/UiPadding';
export function UiCardFooter(_a) {
    var _b = _a.padding, padding = _b === void 0 ? 2 : _b, justifyContent = _a.justifyContent, children = _a.children;
    return (React.createElement(UiPadding, { inner: padding },
        React.createElement(UiFlex, { className: clsx('UiCardFooter'), justifyContent: justifyContent }, children)));
}
